// Auto-generated index file for locale exports
import en from './en'
import fr from './fr'
import nl from './nl'
import de from './de'
import bg from './bg'
import hr from './hr'
import cs from './cs'
import hu from './hu'
import it from './it'
import pl from './pl'
import ro from './ro'
import sl from './sl'
import es from './es'
import tr from './tr'
import el from './el'
import ar from './ar'
import pt from './pt'
import tw from './tw'
import lt from './lt'
import lv from './lv'
import et from './et'
import id from './id'
import sk from './sk'
import vi from './vi'
import th from './th'

const locales = {
  en: en,
  fr: fr,
  nl: nl,
  de: de,
  bg: bg,
  hr: hr,
  cs: cs,
  hu: hu,
  it: it,
  pl: pl,
  ro: ro,
  sl: sl,
  es: es,
  tr: tr,
  el: el,
  ar: ar,
  pt: pt,
  tw: tw,
  lt: lt,
  lv: lv,
  et: et,
  id: id,
  sk: sk,
  vi: vi,
  th: th
}

export default locales
